import type { Client, RequestContext } from "../client";
export type CreateParentEnvironmentCommand = {
    spaceId: string;
    name: string;
    slug?: string;
    description?: string;
};
export type CreateParentEnvironmentResponse = {
    Id: string;
};
export class ParentEnvironmentRepository {
    protected client: Client;
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    async create(command: CreateParentEnvironmentCommand): Promise<CreateParentEnvironmentResponse> {
        return await this.client.create<CreateParentEnvironmentCommand, CreateParentEnvironmentResponse>(this.requestContext, `~/api/spaces/{spaceId}/parentEnvironments`, command, {
            name: command.name,
            spaceId: command.spaceId,
        });
    }
}
